document.addEventListener('change', function(event) {
  var select = event.target.closest('[custom-variant-change]');
  if (!select) return;
  var price = select.closest('.swatch-proinfo').querySelector('.swatch-price');
  if (price && select.selectedOptions[0]) price.textContent = select.selectedOptions[0].getAttribute('data-price');
});
(function() {
  var pending;
  function refreshBold() {
    clearTimeout(pending);
    pending = setTimeout(function() {
      var emitter = window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter;
      if (emitter && typeof emitter.emit === 'function') emitter.emit('BOLD_COMMON_cart_loaded');
    }, 200);
  }
  function protectOptions() {
    document.querySelectorAll('.bold_options_loaded').forEach(function(options) {
      if (!options.children.length) return;
      var section = options.closest('.shopify-section') || options.closest('[data-section-type]');
      if (section) section.querySelectorAll('.shopify-payment-button').forEach(function(button) { button.hidden = true; });
    });
  }
  function start() {
    protectOptions();
    new MutationObserver(function(records) {
      if (records.some(function(record) { return record.addedNodes.length; })) protectOptions();
    }).observe(document.body, {childList: true, subtree: true});
    var cart = document.querySelector('#mini-cart');
    if (cart) new MutationObserver(function() {
      if (cart.getAttribute('aria-hidden') === 'false') refreshBold();
    }).observe(cart, {attributes: true, attributeFilter: ['aria-hidden']});
    refreshBold();
  }
  document.addEventListener('cart:rerendered', refreshBold);
  document.addEventListener('product:added', refreshBold);
  document.addEventListener('shopify:section:load', protectOptions);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

(function() {
  var bases = {
    base1: ['Base 1', 'Pastel Base', 'Clear Tint Base', 'Tintable White'],
    base2: ['Base 2', 'Tint Base', 'Clear Tint Base', 'Tintable White'],
    base3: ['Base 3', 'Deep Base', 'Clear Tint Base', 'Tintable White'],
    base4: ['Base 4', 'Clear Base', 'Clear Tint Base', 'Tintable White', 'Accent Base', 'Neutral Base']
  };
  function bind() {
    document.querySelectorAll('magical-color-variants .tint-color-input').forEach(function(field) {
      var section = field.closest('.shopify-section');
      if (section) section.classList.add('townline-tint-picker');
      if (field.dataset.townlineBound) return;
      field.dataset.townlineBound = 'true';
      field.addEventListener('selection', function(event) {
        var selected = event.detail && event.detail.selection && event.detail.selection.value;
        if (!selected) return;
        var options = bases['base' + selected.base] || [String(selected.base)];
        var wrapper = field.closest('.shopify-section');
        if (!wrapper) return;
        var input = Array.from(wrapper.querySelectorAll('variant-picker [data-townline-option-value]')).find(function(option) {
          return options.indexOf(option.dataset.townlineOptionValue) !== -1 && !option.disabled;
        });
        if (input && !input.checked) input.click();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  new MutationObserver(bind).observe(document.documentElement, {childList:true, subtree:true});
})();
